import React from 'react';

const UploadPrompt = ({ onClick, onDragOver, onDragLeave, onDrop, isDragOver, onUseDefault }) => (
    <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '24px',
            padding: '40px',
            textAlign: 'center',
            background: isDragOver ? 'rgba(74, 134, 232, 0.05)' : 'white',
            transition: 'all 0.3s ease',
            borderRadius: '8px'
        }}
    >
        {/* Upload icon */}
        <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'rgba(74, 134, 232, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '8px'
        }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4a86e8" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
        </div>

        <div style={{ maxWidth: '400px' }}>
            <div style={{ 
                fontSize: '20px', 
                color: '#333',
                marginBottom: '12px',
                fontWeight: '500'
            }}>
                Upload your map
            </div>
            <div style={{ 
                fontSize: '14px', 
                color: '#666',
                marginBottom: '24px',
                lineHeight: '1.5'
            }}>
                Drag and drop your map image here, or click to select a file
            </div>
        </div>

        <div style={{ 
            display: 'flex', 
            gap: '12px',
            flexWrap: 'wrap',
            justifyContent: 'center'
        }}>
            <button
                onClick={onClick}
                style={{
                    padding: '12px 24px',
                    background: '#4a86e8',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(74, 134, 232, 0.2)',
                    ':hover': {
                        background: '#3b78e7',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(74, 134, 232, 0.3)'
                    }
                }}
            >
                Choose File
            </button>
            <button
                onClick={onUseDefault}
                style={{
                    padding: '12px 24px',
                    background: 'white',
                    color: '#4a86e8',
                    border: '1px solid #4a86e8',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    ':hover': {
                        background: 'rgba(74, 134, 232, 0.05)'
                    }
                }}
            >
                Use Default Map
            </button>
        </div>

        <div style={{ 
            fontSize: '12px', 
            color: '#999',
            marginTop: '12px'
        }}>
            Supported formats: PNG, JPEG
        </div>
    </div>
);

export default UploadPrompt; 